import React from "react";
import { Form } from "antd";
import InputName from "../../components/input-name";
import { useTranslation } from "react-i18next";
import styles from './_WorkflowEtapaNome.less';
import PropTypes from "prop-types";

export default function WorkflowEtapaNome(props) {
  const { nome, edicao, onEdicao, onSubmit } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const fireEdicao = (edicao) => {
    if (typeof onEdicao === 'function')
      onEdicao(edicao);
  }

  const fireSubmit = nome => {
    let promise = Promise.resolve();
    if (typeof onSubmit === 'function')
      promise = promise.then(() => onSubmit(nome));
    return promise;
  }

  const handleClick = e => {
    e.preventDefault();
    form.resetFields();
    fireEdicao(true);
  }

  const handleBlur = e => {
    fireEdicao(false);
  }

  const handleFinish = values => {
    fireSubmit(values.nome).then(() => fireEdicao(false));
  }

  if (edicao) {
    return (
      <Form form={form} onFinish={handleFinish} size="middle">
        <Form.Item name="nome" initialValue={nome} noStyle>
          <InputName autoFocus placeholder={t('Nome')} onBlur={handleBlur}/>
        </Form.Item>
      </Form>
    );
  }

  return (
    <div className={styles['workflow-etapa-nome']} onClick={handleClick}>
      {nome}
    </div>
  );
}

WorkflowEtapaNome.propTypes = {
  nome: PropTypes.string,
  edicao: PropTypes.bool,
  onEdicao: PropTypes.func,
  onSubmit: PropTypes.func
}